import { TimesheetAccount } from 'entities/timesheet';
import { formatDateRangeFull } from 'shared/lib/dayjs';
import { AccountRow } from '../TimesheetsTable.types';

export const mapToTableData = (accounts: TimesheetAccount[]): AccountRow[] =>
  accounts.map(({ projects, name, ...account }) => ({
    key: account.id,
    accountName: name,
    ...account,
    children: projects.map(({ timesheets, name: projectName, ...project }) => ({
      key: project.id,
      projectName,
      ...project,
      parentStatus: account.periodState,
      children: timesheets.map(({ assignmentStartDate, assignmentEndDate, ...timesheet }) => ({
        key: timesheet.id,
        ...timesheet,
        assignmentDates: formatDateRangeFull({ startDate: assignmentStartDate, endDate: assignmentEndDate }),
        involvement: `${timesheet.involvement}%`,
        billedInvolvement: `${timesheet.billedInvolvement}%`,
        parentStatus: project.periodState,
      })),
    })),
  }));
